<template>
  <div class="promo-wrap ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-10 offset-xl-1">
          <h2 class="section-title style-four pb-100 white">
            Strategic Market Focus: Launch Strategy
          </h2>
        </div>
      </div>
      <div class="promo-bg bg-f">
        <div class="content-wrap">
          <div class="content-title style-one">
            <h6 class="section-subtitle">
              Flagship Unit <span>Launch</span>
            </h6>
            <h2 style="color: #b5ff00;">Nassau County, Long Island</h2>
            <p>
              Nassau County is strategically selected as the launch market due to its ideal demographic profile: 1.39 million residents, median household income of $143,000, and a significant Muslim population (48,000+) alongside a substantial Hispanic community (256,000+).
            </p>
            <ul class="strategy-list list-style">
              <li>Strong demand for combined with Mexican cuisine appreciation</li>
              <li>Affluent consumer base with cultural diversity</li>
              <li>Ideal testing ground before broader expansion</li>
            </ul>
          </div>
        </div>
        <div class="circle-wrap">
          <img src="../../assets/img/icons/up-right-3.svg" alt="Image" />
          <!-- <router-link class="circle-text" to="/franchise#contact"> -->
          <div class="circle-text">
            <svg
              class="rotate"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="100%"
              height="100%"
              viewBox="0 0 300 300"
              enable-background="new 0 0 300 300"
              xml:space="preserve"
            >
              <defs>
                <path
                  id="circlePath_one"
                  d=" M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0 "
                />
              </defs>
              <circle cx="150" cy="150" r="75" fill="none" />
              <g>
                <use xlink:href="#circlePath_one" fill="none" />
                <text fill="#6b7280">
                  <textPath xlink:href="#circlePath_one">
                    Start Your Journey . Start Your Journey . Start Your Journey
                  </textPath>
                </text>
              </g>
            </svg>
          </div>
          <!-- </router-link> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FranchiseProcess",
});
</script>

<style lang="scss" scoped>
.promo-wrap {
  position: relative;
  z-index: 1;

  .section-title {
    &.style-four {
      text-align: center;
      font-size: 36px;
      font-weight: 700;
      color: #b5ff00;
      margin-bottom: 0;
    }
  }

  .promo-bg {
    position: relative;
    background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
    border-radius: 20px;
    padding: 60px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url('https://images.unsplash.com/photo-1518391846015-55a9cc003b25?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0.15;
      z-index: 1;
      transition: opacity 0.8s ease-in-out;
    }

    &:hover::before {
      opacity: 0.25;
    }

    .content-wrap {
      position: relative;
      z-index: 2;
      max-width: 600px;
      margin: 0 auto;
      text-align: center;

      .content-title {
        h6 {
          font-size: 14px;
          font-weight: 600;
          color: #d1d5db;
          margin-bottom: 15px;

          span {
            color: #9ca3af;
          }
        }

        h2 {
          font-size: 32px;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 20px;
        }

        p {
          font-size: 16px;
          color: #d1d5db;
          line-height: 1.7;
          margin-bottom: 25px;
        }

        .strategy-list {
          list-style: none;
          padding: 0;
          margin: 0;
          text-align: left;

          li {
            background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
            color: #ffffff;
            font-size: 16px;
            font-weight: 500;
            position: relative;
            padding: 15px 20px 15px 50px;
            margin-bottom: 12px;
            border-radius: 8px;
            border: 1px solid rgba(255, 255, 255, 0.1);

            &:last-child {
              margin-bottom: 0;
            }

            &:before {
              position: absolute;
              top: 22px;
              left: 25px;
              content: "";
              width: 10px;
              height: 10px;
              background-color: #6b7280;
              border-radius: 50%;
            }
          }
        }
      }
    }

    .circle-wrap {
      position: absolute;
      top: 50%;
      right: 60px;
      transform: translateY(-50%);
      width: 150px;
      height: 150px;
      z-index: 2;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
      }

      .circle-text {
        position: relative;
        display: block;
        width: 100%;
        height: 100%;

        text {
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 1px;
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .promo-wrap {
    .section-title.style-four {
      font-size: 28px;
    }

    .promo-bg {
      padding: 40px 30px;

      .content-wrap {
        .content-title {
          h2 {
            font-size: 24px;
          }

          .strategy-list li {
            font-size: 14px;
            padding: 12px 20px 12px 45px;
          }
        }
      }

      .circle-wrap {
        display: none;
      }
    }
  }
}
</style>
